import { StepSection } from '../models/step-section.interfaces';

export const stepSectionStoryData: StepSection = {
  step: '2',
  title: 'Delta eCredit Details',
  subtitle: 'All fields required unless noted',
  description:
    "Unfortunately, this ticket is non refundable but is eligible for a Delta eCredit. If you have questions, view your <a style=' font-family: var(--font-family-semibold); font-weight: var(--font-weight-600);' href='https://www.delta.com/us/en/travel-update-center/overview' target='_blank'>refund eligibility</a> for this trip or <a  href='https://www.delta.com/us/en/travel-update-center/overview' style=' font-family: var(--font-family-semibold); font-weight: var(--font-weight-600);'  target='_blank'>message us directly</a>."
};
